var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"footer-info container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5 col-sm-offset-1"},[_c('h1',[_vm._v("ABOUT US")]),_c('p',[_vm._v(_vm._s(_vm.basicInfo.aboutUs))])]),_c('FooterInfoContact',{attrs:{"phone":_vm.basicInfo.phone,"email":_vm.basicInfo.email}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }